import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import debounce from 'lodash/debounce';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import Pagination from '@bibliocommons/pagination';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';
import { searchQueryShape } from '@bibliocommons/bc-prop-types';
import BaseAddTitle, { CatalogueResults } from './components';

import './AddTitle.scss';

export class AddTitle extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      doneButtonContainerWidth: 0,
      isInitialSearch: true,
      results: null
    };
    bindAll(this);
  }

  static getDerivedStateFromProps(props, state) {
    const results = props.results;
    if (state.isInitialSearch) {
      const isQueryTheSame = props.searchQuery.get('query') === state.query && results === state.results;
      const hasResultsChanged = results !== state.results;
      return isQueryTheSame || hasResultsChanged ? { isInitialSearch: false, results } : { results };
    }
    return { results };
  }

  componentDidMount() {
    window.addEventListener('resize', debounce(this.handleResize, 100));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleCatalogueSearch(query) {
    const { searchActions, searchQuery } = this.props;
    const curPage = query === searchQuery.get('query') ? searchQuery.get('page') : 1;
    searchActions.addTitleSearch({
      ...searchQuery.toJS(),
      query,
      page: curPage
    });
    this.setState({ query });
  }

  handleResize() {
    if (this._doneButtonContainer && this._addTitleWrapper) {
      this.setState({
        doneButtonContainerWidth: `${this._addTitleWrapper.offsetWidth}px`
      });
    }
  }

  handlePagination(page) {
    const { searchActions, searchQuery } = this.props;
    searchActions.addTitleSearch({
      ...searchQuery.toJS(),
      page
    });
  }

  handleCatalogueSearchResults() {
    const { zeroResults, results, availabilityDetailActions, addRowClassNames } = this.props;

    if (this.state.isInitialSearch || (zeroResults && !this.state.query)) {
      return null;
    }
    if (zeroResults && this.state.query) {
      return (
        <div className="no-results-found">
          <FormattedMessage id="add_title_no_results_found" />
        </div>
      );
    }

    return (
      <div>
        <div className="pagination-holder">
          {this.renderPagination(true)}
          <CatalogueResults
            className="clearfix"
            searchResults={results}
            availabilityDetailActions={availabilityDetailActions}
            renderAddOn={item => this.props.renderAddOn(item)}
            addRowClassNames={addRowClassNames}
          />
          {this.renderPagination(false, 'pagination-right')}
        </div>
        <div
          className="clearfix done-button-container"
          style={{ width: this.state.doneButtonContainerWidth }}
          ref={el => {
            this._doneButtonContainer = el;
          }}
        >
          {this.renderAlert()}
          <PrimaryButton className="done-button" handleClick={this.props.handleClose}>
            <FormattedMessage id="done" />
          </PrimaryButton>
        </div>
      </div>
    );
  }

  addTitleRef(el) {
    this._addTitleWrapper = el;
  }

  renderAlert() {
    return this.props.renderAlert ? this.props.renderAlert() : null;
  }

  renderPagination(focus, className = '') {
    const { isFetching, pagination } = this.props;
    return (
      <Pagination
        compact
        className={className}
        autoFocus={focus}
        isFetching={isFetching}
        textKey="Search.paginationInfo"
        pagination={pagination}
        handleClick={this.handlePagination}
      />
    );
  }

  render() {
    const { isFetching, isWrappedInForm } = this.props;
    const catalogueSearchOptions = {
      tabName: 'catalogue search',
      searchLabel: <FormattedMessage id="search_by_keyword" />,
      handleSearch: this.handleCatalogueSearch,
      renderResults: this.handleCatalogueSearchResults,
      query: this.state.query
    };

    return (
      <div className="cp-shared-add-title">
        <div className="add-title-wrapper" ref={this.addTitleRef}>
          <BaseAddTitle
            catalogueOptions={catalogueSearchOptions}
            onUpdateHandle={this.handleResize}
            searching={isFetching}
            isWrappedInForm={isWrappedInForm}
          />
        </div>
      </div>
    );
  }
}

AddTitle.propTypes = {
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  renderAlert: PropTypes.func,
  searchQuery: searchQueryShape.isRequired,
  pagination: ImmutablePropTypes.map.isRequired,
  zeroResults: PropTypes.bool.isRequired,
  results: ImmutablePropTypes.list.isRequired,
  handleClose: PropTypes.func.isRequired,
  addRowClassNames: PropTypes.func,
  renderAddOn: PropTypes.func,
  isFetching: PropTypes.bool,
  isWrappedInForm: PropTypes.bool
};

AddTitle.defaultProps = {
  renderAddOn: () => {},
  isWrappedInForm: false
};

export default AddTitle;
